import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";

export function useContractUpdateActionService(actionUrl: string | undefined) {
  return useMutation<void, Error, void>({
    mutationFn: () => axiosInstance().post(actionUrl!).then((r) => r.data),
  });
}
